<template>
  <div
    v-show="this.$store.state.layout === 'default'"
    class="min-height-300 position-absolute w-100"
    :class="`${this.$store.state.darkMode ? 'bg-transparent' : 'bg-success'}`"
  />
  <aside
    class="my-3 overflow-auto border-0 sidenav navbar navbar-vertical navbar-expand-xs border-radius-xl fixed-start ms-3"
    :class="` 
      ${this.$store.state.layout === 'landing' ? 'bg-transparent shadow-none' : ' '} ${
      this.$store.state.sidebarType
    }`"
    id="sidenav-main"
  >
    <div class="sidenav-header" style="height: fit-content;">
      <router-link class="navbar-brand text-center" to="/">
        <img :src="`/${logo}`" class="h-100" alt="main_logo" v-if="logo"/>
        <span v-else class="ms-1 font-weight-bold">Izin Stasiun Radio</span>
      </router-link>
    </div>
    <hr class="mt-0 horizontal dark" />
    <sidenav-list :cardBg="custom_class" />
  </aside>
</template>

<script>
import SidenavList from "./SidenavList.vue";

const logo = JSON.parse(localStorage.getItem("group_data"));

export default {
  name: "index",
  components: {
    SidenavList,
  },
  data() {
    return {
      logo: logo ? logo.logo : null,
    };
  },
  props: ["custom_class", "layout"],
};
</script>
